import NewStage from './NewStage';

export default NewStage;
